import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import RoomModal from './RoomModal';
import HotelPayment from './HotelPayment';
import PaymentSuccess from './PaymentSuccess';

function RoomRateCard({ room, bookingData, hotelId }) {
  const [show, setShow] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showPaymentSuccessModal, setShowPaymentSuccessModal] = useState(false);
  const showDetail = () => setShow(true);
  const handleClose = () => setShow(false);

  const showDetailPayment = () => {
    handleClose();
    setShowPaymentModal(true);
  };
  const paymentSuccess = () => {
    setShowPaymentModal(false);
    setShowPaymentSuccessModal(true);
  };

  const handleClosePayment = () => setShowPaymentModal(false);
  const rateData = room.rate_data;
  const isCancelable = () => {
    if (rateData.refund_type === 'FULL') {
      return ', CANCELABLE';
    }
    return ', NON CANCELABLE';
  };

  const roomDescription = () => {
    if (room.description !== 'NULL') {
      return <div className="cancellation-description">{room.description}</div>;
    }
    return '';
  };
  const getCashBackText = () => {
    if (rateData.inventory_type === 'PCLN') {
      return '10% SELECT Cash';
    }
    if (rateData.inventory_type === 'AGD') {
      return '8% SELECT Cash';
    }
    if (rateData.inventory_type === 'BKG') {
      return '5% SELECT Cash';
    }
    return '';
  };

  // eslint-disable-next-line no-unused-vars
  const getPriceInfo = () => {
    if (rateData.benchmark_price_details.saving_percentage > 0) {
      return (
        <>
          <span className="text-decoration-line-through text-muted mx-2">${(Math.round(rateData.benchmark_price_details.display_price * 100) / 100).toFixed(2)}</span>
          <span className="fs-5 select-color">${(Math.round(rateData.price_details.display_price * 100) / 100).toFixed(2)}</span>
          <span className="ms-2 fs-6 rounded p-1 border border-select select-color">{rateData.benchmark_price_details.saving_percentage}% off</span>
        </>
      );
    }
    return (
      <>
        <span className="fs-5 select-color">${(Math.round(rateData.price_details.display_price * 100) / 100).toFixed(2)}</span>
        <span className="ms-2 fs-6 rounded p-1 border border-select select-color">{getCashBackText()}</span>
      </>
    );
  };
  return (
    <>
      <RoomModal show={show} handleClose={() => handleClose()} room={room} payment={() => showDetailPayment()} />
      <HotelPayment show={showPaymentModal} hotelId={hotelId} paymentSuccess={paymentSuccess} handleClose={() => handleClosePayment()} room={room} bookingData={bookingData} />
      <PaymentSuccess show={showPaymentSuccessModal} handleClose={() => setShowPaymentSuccessModal(false)} />
      <Card className="my-2 bg-transparent border-dark">
        <Card.Body>
          <Row>
            <Col md={7} onClick={() => showDetail(true)} className="pointer">
              {room.title}
              {roomDescription()}
              <div>
                <small>
                  {room.rate_data.payment_type} {isCancelable()}
                </small>
              </div>
            </Col>
            <Col>
              <Row>
                <Col className="d-flex align-items-center justify-content-end">{getPriceInfo()}</Col>
              </Row>
              <Row>
                <Col className="d-flex align-items-center justify-content-end mt-2">
                  <Button className="btn-select" onClick={() => setShowPaymentModal(true)}>
                    Book Now
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}

export default RoomRateCard;
